import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';
import PageHero from '../../../components/feature/PageHero';
import { useNavigate } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20assessoria%20em%20Direito%20Penal%20Empresarial.';

const servicos = [
  {
    icon: 'ri-checkbox-circle-line',
    titulo: 'Compliance Criminal',
    descricao: 'Estruturação e revisão de programas de integridade para empresas, com foco na prevenção, detecção e remediação de condutas ilícitas no ambiente corporativo, em conformidade com a Lei Anticorrupção, visando à proteção da reputação empresarial e à preservação da responsabilidade de seus gestores.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    titulo: 'Crimes Tributários',
    descricao: 'Defesa em processos envolvendo sonegação fiscal, omissão de informações ao Fisco, declarações fraudulentas e demais condutas tipificadas na Lei 8.137/1990 e no Código Tributário Nacional.',
  },
  {
    icon: 'ri-bank-line',
    titulo: 'Lavagem de Capitais',
    descricao: 'Assessoria preventiva e defesa em processos de lavagem de dinheiro (Lei 9.613/1998), incluindo investigações do COAF, Ministério Público Federal e demais órgãos de controle financeiro.',
  },
  {
    icon: 'ri-building-4-line',
    titulo: 'Crimes Corporativos',
    descricao: 'Defesa em casos de fraude contábil, gestão fraudulenta, desvio de bens, estelionato corporativo e demais crimes praticados no âmbito de pessoas jurídicas por seus administradores ou colaboradores.',
  },
  {
    icon: 'ri-user-settings-line',
    titulo: 'Defesa de Executivos',
    descricao: 'Representação e defesa de diretores, gerentes e sócios em investigações e processos criminais decorrentes do exercício de funções empresariais, com estratégia focada na distinção entre ato pessoal e ato corporativo.',
  },
  {
    icon: 'ri-radar-line',
    titulo: 'Gestão de Risco Jurídico',
    descricao: 'Mapeamento dos riscos jurídico-criminais da empresa, avaliação de vulnerabilidades em contratos, operações e processos internos, com recomendações práticas para mitigação e adequação legal.',
  },
];

export default function PenalEmpresarialPage() {
  const navigate = useNavigate();

  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Área de Atuação"
        titulo="Penal"
        tituloItalico="Empresarial"
        subtitulo="Assessoria jurídica especializada para empresas e executivos em questões criminais. Prevenção, compliance e defesa com visão estratégica de negócios."
      />

      {/* Intro */}
      <section className="py-[60px] bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Nossa atuação
            </span>
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light leading-snug mb-6">
            Proteção jurídica para <span className="italic text-[#B39B62]">empresas e gestores</span>
          </h2>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            O Direito Penal Empresarial tem assumido papel cada vez mais relevante no Brasil, especialmente diante do fortalecimento dos órgãos de controle, do aumento das investigações corporativas e do rigor da legislação anticorrupção.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            Empresas de todos os portes, assim como seus gestores, podem ser responsabilizados criminalmente por atos relacionados à atividade empresarial — inclusive em situações comuns do dia a dia, como questões tributárias, relações contratuais e decisões de gestão. Nesse contexto, a atuação preventiva, por meio de programas de compliance e assessoria jurídica contínua, é essencial para a proteção do negócio e das pessoas envolvidas.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-3">
            Quando a prevenção não é suficiente, nossa equipe atua de forma estratégica e técnica na defesa de empresas e executivos em investigações, inquéritos e processos criminais, com soluções jurídicas alinhadas à complexidade do ambiente empresarial e às particularidades de cada caso.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 pt-6 border-t border-[#E9D59C]/40">
            <div className="border-b sm:border-b-0 border-[#E9D59C]/40 pb-4 sm:pb-0">
              <div className="font-serif text-lg text-[#B39B62] font-light mb-1 leading-tight">Lei Anticorrupção</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Adequação e defesa sob a Lei 12.846/2013</div>
            </div>
            <div className="border-b sm:border-b-0 border-[#E9D59C]/40 pb-4 sm:pb-0">
              <div className="font-serif text-lg text-[#B39B62] font-light mb-1 leading-tight">LGPD & Compliance</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Conformidade com a Lei Geral de Proteção de Dados</div>
            </div>
            <div>
              <div className="font-serif text-lg text-[#B39B62] font-light mb-1 leading-tight">Investigações</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Representação em investigações corporativas</div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section className="py-[60px] bg-[#F8F5EE]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#B39B62]"></span>
              <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
                Serviços
              </span>
              <span className="h-px w-12 bg-[#B39B62]"></span>
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light">
              O que <span className="italic text-[#B39B62]">abrangemos</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {servicos.map((s) => (
              <div key={s.titulo} className="bg-white border border-[#E9D59C]/40 rounded-lg p-6 hover:-translate-y-1 transition-transform duration-300">
                <h3 className="font-serif text-base text-[#0A1829] font-medium mb-2">{s.titulo}</h3>
                <p className="font-sans text-[#0A1829]/55 text-xs leading-relaxed">{s.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-[60px] bg-white text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light mb-4">
            Proteja sua empresa com <span className="italic text-[#B39B62]">assessoria especializada</span>
          </h2>
          <p className="font-sans text-[#0A1829]/60 text-base leading-relaxed mb-3">
            Entre em contato para uma avaliação do perfil de risco jurídico da sua empresa.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#0A1829] hover:bg-[#B39B62] text-white hover:text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Falar com advogado
            </a>
            <a
              href="/atuacao"
              onClick={(e) => { e.preventDefault(); navigate('/atuacao'); }}
              className="inline-flex items-center justify-center gap-2 border border-[#0A1829]/30 text-[#0A1829] hover:border-[#B39B62] hover:text-[#B39B62] font-sans font-medium text-base px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver todas as áreas
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}